import { Nullable } from '~globals/types';
import { PreferencesTrackingComplaintChannelTypeId } from '~globals/types/enums';
import { getStringifyUrlQueryString } from '~utils/router';

export const validateComplaintType = (
  comparatorChannelTypeId: PreferencesTrackingComplaintChannelTypeId,
  currentChannelTypeId?: PreferencesTrackingComplaintChannelTypeId,
): boolean => currentChannelTypeId === comparatorChannelTypeId;

export const getComplaintAddress = (
  comparatorChannelTypeId: PreferencesTrackingComplaintChannelTypeId,
  currentChannelTypeId?: PreferencesTrackingComplaintChannelTypeId,
  currentAddress?: Nullable<string>,
): string =>
  validateComplaintType(comparatorChannelTypeId, currentChannelTypeId)
    ? currentAddress ?? ''
    : '';

export const getComplaintLinkHrefEmail = (
  email: string,
  trackingCode: string,
): string => {
  const url = getStringifyUrlQueryString({
    url: email,
    query: {
      subject: `Tengo un problema con el pedido ${trackingCode}`,
    },
  });

  return `mailto:${url}`;
};

export const getComplainHrefWhatsapp = (
  phone: string,
  trackingCode: string,
): string =>
  getStringifyUrlQueryString({
    url: 'https://api.whatsapp.com/send',
    query: {
      phone,
      text: `Hola! Tuve un problema con mi pedido ${trackingCode}`,
    },
  });
